module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Bath-df5cd03d5963bda94ef419a270b6af17b9d4f2585e5788fea5be259d717b98ff.svg";